import React from "react";

const QuranCommandsScroller = ({
  isVisible,
  uiLabels,
  canNext,
  canPrev,
  page,
  maxPage,
  onGoNextPage,
  onGoPrevPage,
  onChangePage,
}) => {
  if (!isVisible) {
    return null;
  }

  return (
    <div
      className="quran-commands-scroller"
      dir="ltr"
      onClick={(event) => event.stopPropagation()}
      onPointerUp={(event) => event.stopPropagation()}
    >
      <button
        type="button"
        className="quran-icon-btn quran-commands-btn"
        aria-label={uiLabels.pagePrevious}
        title={uiLabels.pagePrevious}
        disabled={!canNext}
        onClick={onGoNextPage}
      >
        <span className="quran-icon-glyph">←</span>
      </button>

      <input
        className="quran-page-slider"
        type="range"
        min={1}
        max={maxPage}
        step={1}
        value={page}
        onChange={(event) => onChangePage(Number(event.target.value) || 1)}
        aria-label={uiLabels.quickPageScroll}
      />

      <div className="quran-page-slider-value-wrap">
        <span className="quran-page-slider-value">{page}</span>
        <span className="quran-page-slider-max">/{maxPage}</span>
      </div>

      <button
        type="button"
        className="quran-icon-btn quran-commands-btn"
        aria-label={uiLabels.pageNext}
        title={uiLabels.pageNext}
        disabled={!canPrev}
        onClick={onGoPrevPage}
      >
        <span className="quran-icon-glyph">→</span>
      </button>
    </div>
  );
};

export default QuranCommandsScroller;
